// JsFromRoutes CacheKey 75ad03b87252e39b3c9df636a90dcf89
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  exploreSmartAllowances: /* #__PURE__ */ definePathHelper('get', '/employers/employer_renewals/explore_smart_allowances'),
  index: /* #__PURE__ */ definePathHelper('get', '/employers/employer_renewals(/*path)'),
}
